<div class="flex-1 overflow-hidden flex flex-col w-full h-full bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100 transition-colors duration-300">
  <header class="border-b border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-900">
    <div class="w-full px-8 py-4 flex items-center gap-4">
      <a
        routerLink="/chat"
        class="flex items-center justify-center w-8 h-8 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white transition-all active:scale-95">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
      </a>
      <h1 class="text-lg font-semibold text-gray-900 dark:text-white">Knowledge Management</h1>
    </div>

    <!-- Tabs full-width below -->
    <div class="flex gap-0 px-8 -mb-px">
      <button
        (click)="setTab('files')"
        [ngClass]="activeTab === 'files'
          ? 'border-blue-600 text-blue-600 dark:text-blue-400'
          : 'border-transparent text-gray-500'"
        class="px-4 py-2.5 text-sm font-medium border-b-2 transition-colors hover:text-gray-900 dark:hover:text-white">
        Source Files
      </button>
      <button
        (click)="setTab('parsed')"
        [ngClass]="activeTab === 'parsed'
          ? 'border-blue-600 text-blue-600 dark:text-blue-400'
          : 'border-transparent text-gray-500'"
        class="px-4 py-2.5 text-sm font-medium border-b-2 transition-colors hover:text-gray-900 dark:hover:text-white">
        Parsed Files
      </button>
      <button
        (click)="setTab('jobs')"
        [ngClass]="activeTab === 'jobs'
          ? 'border-blue-600 text-blue-600 dark:text-blue-400'
          : 'border-transparent text-gray-500'"
        class="px-4 py-2.5 text-sm font-medium border-b-2 transition-colors hover:text-gray-900 dark:hover:text-white flex items-center gap-2">
        Job History
        @if (newJobsCount > 0) {
          <span class="inline-flex items-center justify-center w-5 h-5 text-[10px] font-bold rounded-full bg-blue-600 text-white">
            {{ newJobsCount > 9 ? '9+' : newJobsCount }}
          </span>
        }
      </button>
    </div>
  </header>

  <!-- File Browser tab — always mounted to preserve folder navigation state -->
  <app-file-browser
    class="flex-1 min-h-0 flex flex-col"
    [style.display]="activeTab === 'files' ? 'flex' : 'none'"
    (notification)="showToast($event)"
    (viewParsedFile)="openParsedFile($event)">
  </app-file-browser>

  <!-- Parsed Files tab — always mounted to preserve folder navigation state -->
  <app-parsed-file-browser
    class="flex-1 min-h-0 flex flex-col"
    [style.display]="activeTab === 'parsed' ? 'flex' : 'none'"
    (notification)="showToast($event, false)"
    [initialParsedKey]="pendingParsedKey"
    (initialParsedKeyConsumed)="pendingParsedKey = null">
  </app-parsed-file-browser>

  <!-- Jobs tab -->
  @if (activeTab === 'jobs') {
    <main class="flex-1 overflow-y-auto w-full px-8 py-8 space-y-8 bg-white dark:bg-gray-900">
      <app-ingestion-list
        [jobs]="jobs"
        [isLoading]="isLoading"
        [listError]="listError"
        [currentPage]="currentPage"
        [totalPages]="totalPages"
        [totalCount]="totalCount"
        (pageChange)="goToPage($event)">
      </app-ingestion-list>
    </main>
  }
</div>

<!-- Toast notification -->
@if (toast) {
  <div class="fixed bottom-6 right-6 z-50 flex items-center gap-3 px-4 py-3 rounded-xl bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 text-sm font-medium shadow-xl max-w-sm">
    <svg class="w-4 h-4 text-green-400 dark:text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
    </svg>
    <span>{{ toast }}</span>
  </div>
}
